const ITEMS = [
  'LDS TOKEN ECONOMY',
  'DECENTRALIZED WEB3 ECOSYSTEM',
  'DIRECT REFERRAL BONUS',
  'LEVEL INCOME',
  'ALPHA CLUB A & B',
  'LEADERSHIP BONUS',
  'ELITE RANK BENEFITS',
  'GLOBAL COMMUNITY',
];

export function Ticker() {
  const loop = [...ITEMS, ...ITEMS];

  return (
    <div className="ticker">
      <div className="ticker-track">
        {loop.map((item, i) => (
          <span className="ticker-item" key={`${item}-${i}`}>
            {item} <span className="sep">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
